import type { Messages } from './messages';

/**
 * Copy for `src/app/tenant/index.tsx` and its context bar
 * (`src/app/_frame/tenant-bar.tsx`) — the sub toolbar, the switcher, the
 * header, the tenant's own loading and error states. Each tab has its own file.
 *
 * Every key starts with `workspace.`. Shared words (save, cancel, retry,
 * statuses, role names) are already in `common.ts` and `vocabulary.ts`.
 */
export const workspace = {
  'workspace.title': 'المنشأة',
  'workspace.tabs': 'أقسام المنشأة',
  'workspace.sectionsOf': 'أقسام المنشأة: {name}',
  'workspace.switch': 'تبديل المنشأة',
  'workspace.switchSearch': 'ابحث باسم المنشأة أو معرّفها',
  'workspace.switchEmpty': 'لا منشأة تطابق هذا البحث. جرّب جزءًا من الاسم، أو المعرّف اللاتيني، أو افتح قائمة المنشآت كاملة.',
  'workspace.switchCurrent': 'المنشأة المفتوحة الآن',
  'workspace.allTenants': 'كل المنشآت',
  'workspace.newTenant': 'منشأة جديدة',
  'workspace.notFoundTitle': 'المنشأة غير موجودة',
  'workspace.notFoundBody': 'لا منشأة بهذا المعرّف على هذا التنصيب. ربما فُتح رابط قديم أو منقوص.',
  'workspace.backToList': 'العودة إلى قائمة المنشآت',
  'workspace.reloadFailed': 'تعذّر تحديث بيانات المنشأة؛ المعروض آخر ما حُمِّل.',

  /* The header's actions (PATCH /tenants/:id). */
  'workspace.actions': 'إجراءات المنشأة',
  'workspace.rename.button': 'إعادة التسمية',
  'workspace.rename.title': 'إعادة تسمية المنشأة',
  'workspace.rename.description': 'يتغيّر الاسم حيث يُعرض. المعرّف {slug} لا يتغيّر، فروابط الدخول المحفوظة تبقى صالحة.',
  'workspace.rename.label': 'اسم المنشأة',
  'workspace.rename.hint': 'حتى 200 حرف.',
  'workspace.rename.save': 'حفظ الاسم',
  'workspace.rename.required': 'اكتب اسمًا للمنشأة.',
  'workspace.rename.tooLong': 'الاسم أطول من 200 حرف.',
  'workspace.rename.unchanged': 'هذا هو الاسم الحالي؛ لا شيء ليُحفظ.',
  'workspace.rename.done': 'صار اسم المنشأة «{name}».',
  'workspace.suspend.button': 'إيقاف المنشأة',
  'workspace.suspend.title': 'إيقاف {name}؟',
  'workspace.suspend.consequence':
    'يُسجَّل خروج كل عضو فيها عند طلبه التالي، ولا يستطيع أحد منهم الدخول حتى يُعاد تفعيلها. لا يُحذف شيء: الحسابات والأدوار والمحتوى والإعدادات تبقى كما هي.',
  'workspace.suspend.affected': 'كل أعضائها: {active} نشطًا من {total} حسابًا.',
  'workspace.suspend.confirm': 'إيقاف المنشأة',
  'workspace.suspend.done': 'أُوقفت {name}، وسيُسجَّل خروج أعضائها عند طلبهم التالي.',
  'workspace.activate.button': 'إعادة التفعيل',
  'workspace.activate.title': 'إعادة تفعيل {name}؟',
  'workspace.activate.consequence':
    'يستطيع أعضاؤها الدخول من جديد بحساباتهم وأدوارهم كما كانت قبل الإيقاف. الجلسات التي انتهت لا تعود؛ يدخل كلٌّ منهم مرة أخرى.',
  'workspace.activate.affected': 'حساباتها: {total}.',
  'workspace.activate.confirm': 'إعادة التفعيل',
  'workspace.activate.done': 'أُعيد تفعيل {name}.',
} as const satisfies Messages<'workspace'>;
